const wx = require('weixin-js-sdk');
import { getWxConfig } from './request';
import { WxShare } from '@/types';

const MyWxJs = {
  getWxConfig: async () => {
    const config = await getWxConfig();
    if (config && config.data && config.data.res) {
      wx.config(config.data.res);
    }
    return config;
  },
  getShareParams(id: number|string, userId: number|string): WxShare {
    const titleArr = ['我，和BT领证了！', '今天，我从BT教育毕业了…'];
    const descArr = ['学海无涯，我们并肩同行。', '愿所有的奋斗都开花结果，所有的努力都不被辜负！', '追逐梦想的日子里，有你相伴。', '寻梦需有志，逐梦需有行，圆梦需有恒。', '以笔为剑，踏上征途。'];
    const title = titleArr[ Math.floor(Math.random() * titleArr.length) ];
    const desc = descArr[ Math.floor(Math.random() * descArr.length) ];
    const link = location.origin + process.env.VUE_APP_ROUTER_BASE_URL + `/${id}/share?userId=${userId}`;
    return {
      title,
      desc,
      link,
      imgUrl: 'https://app-cdn.btclass.cn/dolphin/certificate/share.png',
    };
  },
  share: ({ title, desc, link, imgUrl }: WxShare) => {
    console.log("---wx.ready.share---", title, desc, link, imgUrl);
    wx.hideMenuItems({
      menuList: [
        "menuItem:share:qq",
        "menuItem:share:QZone"
      ] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
    });
    wx.onMenuShareTimeline({
      title: title, // 分享标题
      link: link, // 分享链接
      imgUrl: imgUrl, // 分享图标
      success: function () {
        // 用户确认分享后执行的回调函数
      },
      cancel: function () {
        // 用户取消分享后执行的回调函数
      }
    });
    wx.onMenuShareAppMessage({
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: link, // 分享链接
      imgUrl: imgUrl, // 分享图标
      success: function () {
        // 用户确认分享后执行的回调函数
      },
      cancel: function () {
        // 用户取消分享后执行的回调函数
      }
    });
  }
};

export { wx };
export default MyWxJs;
